import React, { useEffect, useState } from "react";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Transaction from "./component/affiliater/transaction";
import Page from "./component/affiliater/Page";
import {
  formatDate,
  anonymizeText,
} from "../../components/product/component/sharedFunction.js";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";

import Member from "./component/affiliater/Member";

import "./styles/affiliateStyle.css";
import "../../assets/Common.css";

const Affiliate = (currentItems) => {
  return (
    currentItems.currentItems &&
    currentItems.currentItems.map((affiliate, index) => (
      <div key={index} className={``}>
        <Member
          id={affiliate.id}
          avatar={affiliate.avatar}
          invitation_accepted_at={affiliate.invitation_accepted_at}
          plan_created_at={affiliate.plan_created_at}
          comission_counter={
            affiliate.comission_total + affiliate.comission_total_current_month
          }
        ></Member>
        {index < currentItems.currentItems.length - 1 && (
          <hr className="transaction-divider" />
        )}
      </div>
    ))
  );
};

function Affiliater(props) {
  const [link, setLink] = useState(0);
  const [copied, setCopied] = useState(false);
  const [link2, setLink2] = useState(0);
  const [copied2, setCopied2] = useState(false);
  const [index, setIndex] = useState(0);
  const [buttonState, setButtonState] = useState(1);
  const [email, setEmail] = useState("");
  const [errorState, setErrorState] = useState(null);

  const [affiliates, setAffiliates] = useState(0);
  const [transactions, setTransactions] = useState(0);
  const [comissions, setComissions] = useState(0);
  const [itemsPerPage] = useState(5);

  const [posts, setPosts] = useState("");
  const [endOffset, setEndOffset] = useState("");
  const [currentItems, setCurrentItems] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const { user } = props;

  useEffect(() => {
    setLink(`${process.env.REACT_APP_URL}/aff/${user.uuid}`);
    setLink2(`https://screebot.com?aff=${user.uuid}`);
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.replace(process.env.REACT_APP_URL + `/users/sign_in`);
    }
    const config = {
      headers: { Authorization: `${token}` },
    };
    axios
      .get(process.env.REACT_APP_URL_API + "/affiliate_information", config)
      .then((response) => {
        // setNbAffiliate(response['data'].nbAffiliate);
        setAffiliates(response["data"].affiliates);
        setComissions(response["data"].comissions);

        setPosts(response["data"].affiliates);
        setEndOffset(itemOffset + itemsPerPage);
        setCurrentItems(
          response["data"].affiliates.slice(itemOffset, endOffset)
        );
        setPageCount(
          Math.ceil(response["data"].affiliates.length / itemsPerPage)
        );
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(process.env.REACT_APP_URL_API + "/get_transactions", config)
      .then((response) => {
        setTransactions(response["data"]["transactions"]);
      })
      .catch((error) => {
        console.log(error);
      });
    const queryParameters = window.location.search;
    switch (queryParameters) {
      case "?dashboard":
        setIndex(0);
        break;
      case "?invitation":
        setIndex(1);
        break;
      case "?accounting":
        setIndex(2);
        break;
      case "?guide":
        setIndex(3);
        break;
      default:
        break;
    }
  }, [user, itemOffset, endOffset, itemsPerPage]);

  const setMaxThreeEmails = (value) => {
    const input = document.getElementById("email");
    const commaCount = (value.match(/,/g) || []).length;

    if (commaCount > 2) {
      input.classList.add("border-error");
    } else {
      input.classList.remove("border-error");
      setEmail(value);
    }
  };

  const urlName = (index) => {
    switch (index) {
      case 0:
        return "dashboard";
      case 1:
        return "invitation";
      case 2:
        return "accounting";
      case 3:
        return "guide";
      default:
        return "";
    }
  };

  const setPageAndIndex = (index) => {
    setIndex(index);
    navigate(`/users/affiliater?${urlName(index)}`);
  };

  function updateState(state = null) {
    if (state === null) {
      let tmpButtonState = buttonState + 1;
      if (tmpButtonState === 3) {
        tmpButtonState = 1;
        setEmail("");
      }
      setButtonState(tmpButtonState);
    } else {
      setButtonState(state);
    }
  }

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % posts.length;
    setItemOffset(newOffset);
  };

  const copyLink = () => {
    setCopied(!copied);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const copyLink2 = () => {
    setCopied2(!copied2);
    setTimeout(() => {
      setCopied2(false);
    }, 1000);
  };

  const inviteMember = (event) => {
    event.preventDefault();
    event.stopPropagation();
    let token = localStorage.getItem("token");
    if (!token) {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpiration");
      window.location = process.env.REACT_APP_URL + "/users/sign_in";
      return;
    }
    if (email === "" || undefined) {
      updateState(1);
      setErrorState("Remplissez le champs email");
      return;
    }
    if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      updateState(1);
      setErrorState("L'email ne semble pas valide");
      return;
    }
    updateState(2);
    const config = {
      headers: { Authorization: `${token}` },
    };
    let data = {
      email: email,
      role: "client",
      language:
        localStorage.getItem("i18nextLng") || localStorage.getItem("language"),
      invitation: "affiliate",
    };
    setErrorState(null);
    axios
      .post(process.env.REACT_APP_URL_API + "/invitation", data, config)
      .then((res) => {
        if (res.data !== null) {
          if (res.status === 201) {
            const newUsers = res.data["user"];
            const updatedUsers = newUsers.map((user) => ({
              ...user,
              avatar: null,
              invitation_accepted_at: null,
              comission_total: 0,
              plan: null,
            }));
            setAffiliates((prevResults) => [...prevResults, ...updatedUsers]);
            setCurrentItems((prevResults) =>
              [...prevResults, ...updatedUsers].slice(itemOffset, endOffset)
            );
          }
        }
      })
      .catch((res) => {
        if (res.status === 500) {
          setErrorState(res.response.data.error);
          updateState(1);
          return;
        }
        if (res.status === 422) {
          setErrorState(i18n.t(`team.error_${res.response.data.error}`));
          updateState(1);
          return;
        }
        if (
          res.data === "Signature has expired" ||
          res.data === "No verification key available"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiration");
          window.location = process.env.REACT_APP_URL + "/users/sign_in";
          return;
        }
        if (res.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiration");
          window.location = process.env.REACT_APP_URL + "/users/sign_in";
          return;
        }
      });
  };

  return (
    user && (
      <div className="container text-left gap-y-2.5">
        <h1 className="text-secondary pb-2.5 text-left">
          Mon espace affiliation
        </h1>
        <div className="flex flex-col gap-y-6">
          <Page page={index} setPage={setPageAndIndex} />
          <hr className="separator-product"></hr>
          {index === 0 && (
            <>
              <h3 className="text-primary font-semibold text-lg">
                Informations globales
              </h3>
              <div className="flex flex-row mt-auto whitespace-nowrap">
                <div className="label text-secondary text-md font-semibold">
                  Commission de ce mois-ci : &nbsp;
                  <span className="label text-primary text-lg font-semibold">
                    {comissions.comission_total_current_month} €
                  </span>
                </div>
              </div>

              <div className="flex flex-row gap-x-6">
                <div className="screebot-card flex-col w-full gap-x-1">
                  <div
                    style={{ paddingBottom: "2rem" }}
                    className="account-subtitle text-primary text-lg font-medium"
                  >
                    Commissions d’affiliation
                  </div>
                  <div className="flex flex-col gap-y-1">
                    <div className="small-card-screebot justify-between">
                      <div className="flex flex-col gap-y-1">
                        <span className="text-primary font-medium">
                          Année en cours
                        </span>
                        <span className="text-gray">
                          {new Date().getFullYear()}
                        </span>
                      </div>
                      <div className="my-auto text-md">
                        <span className="text-green label font-extrabold text-md">
                          {parseFloat(
                            comissions.comission_total_current_month || 0
                          ) +
                            parseFloat(
                              comissions.current_year_comission_year || 0
                            )}
                        </span>
                        <span className="text-md label text-primary text-sm font-medium">
                          {" "}
                          € HT
                        </span>
                      </div>
                    </div>
                    <div className="small-card-screebot justify-between">
                      <div className="flex flex-col gap-y-1">
                        <span className="text-primary font-medium">
                          Trimestre en cours
                        </span>
                        <span className="text-gray">
                          {Math.ceil((new Date().getMonth() + 1) / 3)}ème
                          trimestre {new Date().getFullYear()}
                        </span>
                      </div>
                      <div className="my-auto text-md">
                        <span className="text-green label font-extrabold text-md">
                          {parseFloat(
                            comissions.comission_total_current_month || 0
                          ) +
                            parseFloat(
                              comissions.current_year_comission_quarter || 0
                            )}
                        </span>
                        <span className="text-md label text-primary text-sm font-medium">
                          {" "}
                          € HT
                        </span>
                      </div>
                    </div>
                    <div className="small-card-screebot justify-between">
                      <div className="flex flex-col gap-y-1">
                        <span className="text-primary font-medium">
                          Commmisions N+1
                        </span>
                        <span className="text-gray">
                          {new Date().getFullYear() - 1} vs{" "}
                          {new Date().getFullYear()}
                        </span>
                      </div>
                      <div className="my-auto text-md">
                        <span className="text-green label font-extrabold text-md">
                          {comissions.previous_year_comission_year !== 0 ? (
                            <>
                              {comissions.current_year_comission_year >
                              comissions.previous_year_comission_year
                                ? "+"
                                : "-"}
                              {(
                                ((comissions.current_year_comission_year -
                                  comissions.previous_year_comission_year) /
                                  comissions.previous_year_comission_year) *
                                100
                              ).toFixed(2)}
                            </>
                          ) : (
                            "N/C"
                          )}
                        </span>
                        <span className="text-md label text-primary text-sm font-medium">
                          {comissions.previous_year_comission_year !== 0
                            ? " %"
                            : ""}
                        </span>
                      </div>
                    </div>
                    <div className="small-card-screebot justify-between">
                      <div className="flex flex-col gap-y-1">
                        <span className="text-primary font-medium">
                          Depuis l'inscription
                        </span>
                        <span className="text-gray">
                          depuis le {formatDate(user.created_at)}
                        </span>
                      </div>
                      <div className="my-auto text-md">
                        <span className="text-green label font-extrabold text-md">
                          {parseFloat(
                            comissions.comission_total_current_month || 0
                          ) + parseFloat(comissions.comission_total || 0)}
                        </span>
                        <span className="text-md label text-primary text-sm font-medium">
                          {" "}
                          € HT
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="screebot-card flex flex-col w-full gap-x-1">
                  <div
                    style={{ paddingBottom: "2rem" }}
                    className="account-subtitle text-primary text-lg font-medium"
                  >
                    Dernières affiliations
                  </div>
                  <div className="">
                    {!affiliates?.length > 0 && (
                      <div className="text-error font-medium text-lg">
                        Aucun affilié
                      </div>
                    )}
                    {affiliates?.length > 0 &&
                      affiliates.slice(0, 4).map((affiliate, index) => (
                        <div
                          key={index}
                          className={`small-card-screebot justify-between`}
                        >
                          <div className="flex flex-col">
                            <span className="text-sm text-primary text-left">
                              {affiliate.first_name === null
                                ? "N/C"
                                : affiliate.first_name}{" "}
                              {affiliate.last_name === null
                                ? "N/C"
                                : anonymizeText(affiliate.last_name, "full")}
                            </span>
                            <span className="text-xs text-secondary">
                              {anonymizeText(
                                affiliate.email.substring(0, 30),
                                "start_to_end"
                              )}
                            </span>
                          </div>
                          <div className="text-sm text-center my-auto">
                            {affiliate.plan === null && (
                              <span className="text-xs text-error">N/C</span>
                            )}
                            {affiliate.plan !== null && (
                              <span className="text-green badge-plan-affiliate">
                                {affiliate.plan.name}
                              </span>
                            )}
                          </div>
                          <span className="text-sm text-right text-secondary my-auto">
                            {formatDate(affiliate.created_at)}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="screebot-card flex flex-col w-full gap-x-1">
                  <div
                    style={{ paddingBottom: "2rem" }}
                    className="account-subtitle text-primary text-lg font-medium"
                  >
                    État de paiement des commissions
                  </div>
                  {!transactions?.length > 0 && (
                    <div className="text-error font-medium text-lg">
                      Aucune transaction
                    </div>
                  )}
                  <div className="flex flex-col gap-y-2">
                    {transactions &&
                      transactions.slice(0, 4).map((transaction, index) => (
                        <a
                          href="?accounting"
                          key={index}
                          className="cursor-pointer"
                        >
                          {/*  className="small-card-screebot" */}
                          <Transaction
                            view="user"
                            from="small_card"
                            transaction={transaction}
                          ></Transaction>
                        </a>
                      ))}
                  </div>
                </div>
              </div>

              <div className="rounded-custom-input w-full bg-white border border-gray-custom-input team-panel flex flex-col gap-y-1">
                {!affiliates?.length > 0 && (
                  <div className="text-error font-medium text-lg">
                    Aucun affilié
                  </div>
                )}
                {affiliates?.length > 0 && (
                  <>
                    <Affiliate currentItems={currentItems}></Affiliate>

                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=">"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="<"
                      renderOnZeroPageCount={null}
                      containerClassName="paginate paginate-affiliater"
                    />
                  </>
                )}
              </div>
            </>
          )}
          {index === 1 && (
            <>
              <div className="flex flex-col gap-y-10">
                <div className="flex flex-col gap-y-1.5 w-full">
                  <h3 className="text-primary font-semibold text-lg pb-5">
                    Liens à communiquer
                  </h3>
                  <div className="flex flex-row gap-x-4">
                    <div className="w-full">
                      <label
                        id="name"
                        className="label text-md text-primary flex-row"
                      >
                        lien site screebot
                      </label>
                      <div className="flex flex-row gap-x-5 mt-1.5 mb-2.5">
                        <div className="flex gap-y-1 relative w-full">
                          <CopyToClipboard
                            onCopy={() => copyLink2()}
                            text={link2}
                            style={{
                              marginLeft: "auto",
                              marginTop: "1rem",
                              marginRight: "1rem",
                              right: "0",
                              top: "0",
                              cursor: "pointer",
                              position: "absolute",
                            }}
                          >
                            <svg
                              width="15"
                              height="18"
                              viewBox="0 0 15 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.7991 5.30778L9.75337 0.202985C9.62527 0.0731077 9.45117 0 9.26969 0H7.01606C6.35062 0 5.71228 0.267508 5.24174 0.743538C4.7712 1.21957 4.50677 1.86535 4.50677 2.53855V3.69249H3.36613C2.70069 3.69249 2.06235 3.96 1.59181 4.43603C1.12154 4.91178 0.857117 5.55757 0.857117 6.23077V15.4614C0.857117 16.1346 1.12154 16.7804 1.59208 17.2565C2.06263 17.7325 2.70097 18 3.36641 18H9.75337C10.4188 18 11.0572 17.7325 11.5277 17.2565C11.9982 16.7804 12.2627 16.1346 12.2627 15.4614V14.3075H12.4907C13.1561 14.3075 13.7945 14.04 14.265 13.564C14.7356 13.0879 15 12.4422 15 11.769V5.76914C14.9929 5.59523 14.9211 5.43046 14.7993 5.30751L14.7991 5.30778ZM9.98139 2.36326L12.664 5.07711H9.98139V2.36298V2.36326ZM10.8937 15.4617C10.8937 15.7677 10.7736 16.0613 10.5598 16.2775C10.346 16.4938 10.0558 16.6154 9.75337 16.6154H3.36641C3.06394 16.6154 2.77378 16.4938 2.56 16.2775C2.34621 16.0613 2.22605 15.7677 2.22605 15.4617V6.23077C2.22605 5.92477 2.34621 5.63123 2.56 5.41495C2.77378 5.19868 3.06394 5.07711 3.36641 5.07711H4.50705V11.7695C4.50705 12.4427 4.77147 13.0885 5.24201 13.5645C5.71256 14.0406 6.3509 14.3081 7.01634 14.3081H10.8943V15.462L10.8937 15.4617ZM12.4904 12.9232H7.01606C6.71359 12.9232 6.42344 12.8016 6.20965 12.5853C5.99587 12.369 5.8757 12.0755 5.8757 11.7695V2.53855C5.8757 2.23255 5.99587 1.93902 6.20965 1.72274C6.42344 1.50646 6.71359 1.38489 7.01606 1.38489H8.61274V5.76914C8.6152 5.95191 8.68801 6.12665 8.81585 6.25597C8.94368 6.38529 9.1164 6.45895 9.29706 6.46145H13.631V11.7692C13.631 12.0752 13.5109 12.3688 13.2971 12.585C13.0833 12.8013 12.7932 12.9229 12.4907 12.9229L12.4904 12.9232Z"
                                fill={"#486497"}
                              />
                            </svg>
                          </CopyToClipboard>
                          <div
                            className={`bg-white border rounded-custom-input padding-custom-input font-normal text-primary w-full ${
                              copied2
                                ? "border-secondary-custom-input"
                                : "border-gray-custom-input"
                            }`}
                            name="link"
                            id="link"
                          >
                            {link2}
                          </div>
                        </div>
                      </div>
                      <label
                        id="name"
                        className="label text-xs text-primary flex-row"
                      >
                        ℹ️ le lien envoie directement vers le site vitrine,
                        l’utilisateur bénéficiera automatique de 1000 crédits.
                        Le cookie est valable 30 jours.
                      </label>
                    </div>
                    <div className="w-full">
                      <label
                        id="name"
                        className="label text-md text-primary flex-row"
                      >
                        lien plateforme
                      </label>
                      <div className="flex flex-row gap-x-5 mt-1.5 mb-2.5">
                        <div className="flex gap-y-1 relative w-full">
                          <CopyToClipboard
                            onCopy={() => copyLink()}
                            text={link}
                            style={{
                              marginLeft: "auto",
                              marginTop: "1rem",
                              marginRight: "1rem",
                              right: "0",
                              top: "0",
                              cursor: "pointer",
                              position: "absolute",
                            }}
                          >
                            <svg
                              width="15"
                              height="18"
                              viewBox="0 0 15 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.7991 5.30778L9.75337 0.202985C9.62527 0.0731077 9.45117 0 9.26969 0H7.01606C6.35062 0 5.71228 0.267508 5.24174 0.743538C4.7712 1.21957 4.50677 1.86535 4.50677 2.53855V3.69249H3.36613C2.70069 3.69249 2.06235 3.96 1.59181 4.43603C1.12154 4.91178 0.857117 5.55757 0.857117 6.23077V15.4614C0.857117 16.1346 1.12154 16.7804 1.59208 17.2565C2.06263 17.7325 2.70097 18 3.36641 18H9.75337C10.4188 18 11.0572 17.7325 11.5277 17.2565C11.9982 16.7804 12.2627 16.1346 12.2627 15.4614V14.3075H12.4907C13.1561 14.3075 13.7945 14.04 14.265 13.564C14.7356 13.0879 15 12.4422 15 11.769V5.76914C14.9929 5.59523 14.9211 5.43046 14.7993 5.30751L14.7991 5.30778ZM9.98139 2.36326L12.664 5.07711H9.98139V2.36298V2.36326ZM10.8937 15.4617C10.8937 15.7677 10.7736 16.0613 10.5598 16.2775C10.346 16.4938 10.0558 16.6154 9.75337 16.6154H3.36641C3.06394 16.6154 2.77378 16.4938 2.56 16.2775C2.34621 16.0613 2.22605 15.7677 2.22605 15.4617V6.23077C2.22605 5.92477 2.34621 5.63123 2.56 5.41495C2.77378 5.19868 3.06394 5.07711 3.36641 5.07711H4.50705V11.7695C4.50705 12.4427 4.77147 13.0885 5.24201 13.5645C5.71256 14.0406 6.3509 14.3081 7.01634 14.3081H10.8943V15.462L10.8937 15.4617ZM12.4904 12.9232H7.01606C6.71359 12.9232 6.42344 12.8016 6.20965 12.5853C5.99587 12.369 5.8757 12.0755 5.8757 11.7695V2.53855C5.8757 2.23255 5.99587 1.93902 6.20965 1.72274C6.42344 1.50646 6.71359 1.38489 7.01606 1.38489H8.61274V5.76914C8.6152 5.95191 8.68801 6.12665 8.81585 6.25597C8.94368 6.38529 9.1164 6.45895 9.29706 6.46145H13.631V11.7692C13.631 12.0752 13.5109 12.3688 13.2971 12.585C13.0833 12.8013 12.7932 12.9229 12.4907 12.9229L12.4904 12.9232Z"
                                fill={"#486497"}
                              />
                            </svg>
                          </CopyToClipboard>
                          <div
                            className={`bg-white border rounded-custom-input padding-custom-input font-normal text-primary w-full ${
                              copied
                                ? "border-secondary-custom-input"
                                : "border-gray-custom-input"
                            }`}
                            name="link"
                            id="link"
                          >
                            {link}
                          </div>
                        </div>
                      </div>
                      <label
                        id="name"
                        className="label text-xs text-primary flex-row"
                      >
                        ℹ️ le lien envoie directement vers la plateforme pour
                        créer un compte directement sans passer par le site
                        vitrine.
                      </label>
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col gap-y-1.5">
                  <h3 className="text-primary font-semibold text-lg pb-5">
                    Invitations par e-mail
                  </h3>
                  <div className="flex flex-col gap-y-1.5">
                    <div className="flex flex-row justify-between w-full">
                      <label
                        id="name"
                        className="label text-md text-primary flex-row"
                      >
                        adresse e-mail de votre contact
                      </label>
                    </div>
                    {/* {buttonState === 0 && (
                      <button
                        className="padding-custom-button flex flex-row gap-x-3 bg-secondary text-white border border-gray-custom-input rounded-custom-input btn whitespace-nowrap"
                        onClick={() => {
                          updateState();
                        }}
                      >
                        <svg
                          className="my-auto"
                          width="15"
                          height="16"
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 10.616C7.21095 10.616 6.97674 10.3818 6.97674 10.0928V8.52304H5.40696C5.11791 8.52304 4.8837 8.28883 4.8837 7.99979C4.8837 7.71075 5.11791 7.47654 5.40696 7.47654H6.97674V5.90681C6.97674 5.61776 7.21095 5.38356 7.5 5.38356C7.78905 5.38356 8.02326 5.61776 8.02326 5.90681V7.47654H9.59304C9.88209 7.47654 10.1163 7.71075 10.1163 7.99979C10.1163 8.28883 9.88209 8.52304 9.59304 8.52304H8.02326V10.0928C8.02326 10.3818 7.78905 10.616 7.5 10.616Z"
                            fill="white"
                          />
                          <path
                            d="M7.5 15.4998C5.80903 15.4998 4.58711 15.4998 3.60255 15.3673C2.49595 15.2185 1.74727 14.897 1.17482 14.3248C0.602587 13.7526 0.281096 13.0039 0.13228 11.8973C0 10.9126 0 9.69092 0 7.99979C0 6.30866 0 5.08719 0.13249 4.10244C0.281305 2.99588 0.602796 2.24722 1.17503 1.67479C1.74727 1.10236 2.49595 0.781088 3.60255 0.632486C4.58732 0.5 5.80903 0.5 7.5 0.5C9.19097 0.5 10.4129 0.5 11.3975 0.632486C12.504 0.781297 13.2527 1.10278 13.825 1.675C14.6645 2.5145 14.8861 3.68448 14.9609 5.18326C14.9753 5.47188 14.753 5.7176 14.4642 5.73183C14.176 5.74669 13.9298 5.524 13.9156 5.23538C13.8396 3.70896 13.6144 2.94461 13.0849 2.41508C12.2165 1.5467 10.6402 1.5467 7.49979 1.5467C4.35939 1.5467 2.78312 1.5467 1.91472 2.41508C1.04631 3.28346 1.04631 4.85969 1.04631 8C1.04631 11.1403 1.04631 12.7165 1.91472 13.5849C2.78312 14.4535 4.35939 14.4535 7.49979 14.4535C10.6402 14.4535 12.2165 14.4535 13.0849 13.5851C13.9535 12.7167 13.9535 11.1405 13.9535 8.00021C13.9535 7.71117 14.1877 7.47696 14.4767 7.47696C14.7658 7.47696 15 7.71117 15 8.00021C15 9.69113 15 10.913 14.8675 11.8976C14.7187 13.0041 14.3972 13.7528 13.825 14.325C13.2527 14.8972 12.504 15.2189 11.3975 15.3675C10.4129 15.5 9.19097 15.5 7.5 15.5V15.4998Z"
                            fill="white"
                          />
                        </svg>
                        {`inviter un affilié par e-mail`}
                      </button>
                    )} */}
                    {buttonState === 1 && (
                      <div className="flex flex-col gap-y-1">
                        <form
                          className="flex flex-row gap-x-7 "
                          onSubmit={(e) => {
                            inviteMember(e);
                          }}
                        >
                          <input
                            value={email}
                            onChange={(e) => setMaxThreeEmails(e.target.value)}
                            id="email"
                            name="email"
                            style={{ width: "100%" }}
                            className={`input-team-add ${
                              errorState === null ? "" : "border-error"
                            }`}
                            placeholder="adresses e-mail (séparées par des virgules si multiples)"
                          ></input>
                          <button className="bg-white text-secondary btn button-product text-sm whitespace-nowrap">
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.2406 6.98079C13.1478 6.81834 13.0085 6.7023 12.8461 6.60947L2.14743 0.621951C1.96177 0.529121 1.7529 0.482707 1.54404 0.505914C1.33517 0.529121 1.14951 0.598744 0.987059 0.737988C0.824607 0.877233 0.70857 1.06289 0.662155 1.24855C0.592533 1.45742 0.61574 1.66629 0.685362 1.87515L2.6812 7.51456L0.685362 13.154C0.61574 13.3628 0.61574 13.5717 0.662155 13.7574C0.70857 13.9662 0.824607 14.1287 0.987059 14.2679C1.14951 14.4072 1.33517 14.4768 1.54404 14.5C1.56725 14.5 1.61366 14.5 1.63687 14.5C1.79932 14.5 1.98498 14.4536 2.14743 14.3608L12.8461 8.37324C13.0085 8.28041 13.1478 8.16437 13.2406 8.00192C13.3334 7.83946 13.3798 7.65381 13.3798 7.49135C13.3798 7.3289 13.3334 7.14324 13.2406 6.98079ZM1.68328 1.55025L11.384 6.98079H3.6095L1.68328 1.55025ZM1.68328 13.4789L3.63271 8.04833H11.4072L1.68328 13.4789Z"
                                fill="#486497"
                              />
                            </svg>
                            envoyer l’invitation
                          </button>
                        </form>
                        <span className="text-error">{errorState}</span>
                      </div>
                    )}
                    {buttonState === 2 && (
                      <div className="flex flex-row gap-x-2">
                        <div className="flex flex-row gap-x-3 label text-secondary my-auto text-md">
                          <svg
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.6743 1.232C10.6036 1.28046 10.3354 1.58276 10.5512 2.47004C10.7347 3.22427 10.858 3.72679 10.9353 4.04052C10.971 4.18526 10.9969 4.2898 11.0145 4.36031C11.1212 4.49856 11.227 4.63769 11.3315 4.77718C11.6239 5.16726 11.9079 5.5622 12.1745 5.95049C12.122 5.70386 12.0678 5.45632 12.0124 5.21042C11.8207 4.35919 11.6171 3.53763 11.4242 2.85345C11.2275 2.15566 11.0529 1.64091 10.9245 1.377C10.8646 1.25384 10.7989 1.22077 10.7723 1.21237C10.7463 1.20414 10.7147 1.20432 10.6743 1.232ZM13.962 9.31643C13.8303 8.20797 13.5133 6.51976 13.1572 4.93814C12.9622 4.07235 12.7532 3.22849 12.5528 2.5174C12.3562 1.81991 12.1567 1.20952 11.9755 0.836982C11.7906 0.456986 11.4891 0.175563 11.1179 0.0581786C10.7461 -0.0593836 10.3493 0.00332921 10.0226 0.227228C9.44279 0.624461 9.20058 1.40396 9.33112 2.34496C9.28064 2.2898 9.23043 2.23547 9.18055 2.18203C8.50561 1.45908 7.83277 0.837361 7.30652 0.566938C6.59847 0.203088 5.76816 0.350736 5.33228 1.02414C4.90686 1.6814 5.01552 2.58709 5.57516 3.45357C5.83553 3.85671 6.30042 4.40896 6.76711 4.96335C6.88997 5.10929 7.01294 5.25537 7.13235 5.39893C7.13299 5.3997 7.13363 5.40047 7.13427 5.40125C7.11735 5.39449 7.10044 5.3878 7.08357 5.38118C6.57796 5.18299 6.04986 5.03166 5.57506 5.03166C5.06593 5.03166 4.45521 5.25963 3.8912 5.5502C3.30646 5.85145 2.69081 6.26278 2.15066 6.7147C1.61633 7.16174 1.12297 7.67588 0.814258 8.19254C0.524733 8.6771 0.28191 9.37544 0.684249 9.99568C0.753721 10.1028 0.830872 10.2 0.915872 10.286C0.825536 10.3399 0.74013 10.3999 0.660454 10.4654C0.128183 10.9027 -0.218024 11.6736 0.158015 12.4466C0.410096 12.9648 0.846437 13.5419 1.36172 14.1422C1.88367 14.7504 2.51994 15.42 3.19975 16.124C3.86233 16.8102 4.80821 17.5104 6.00929 17.8268C7.22378 18.1468 8.65449 18.0619 10.244 17.2451C11.8181 16.4362 12.7843 15.3951 13.3375 14.0833C13.8784 12.8005 14 11.3123 14 9.66076C14 9.54979 13.986 9.4341 13.962 9.31643ZM12.8026 9.52168C12.8105 9.59099 12.8176 9.65745 12.8237 9.72083L12.825 9.7207C12.8219 11.3112 12.6943 12.5717 12.2594 13.6031C11.8312 14.6185 11.0819 15.4644 9.71852 16.165C8.37055 16.8577 7.22931 16.9016 6.30106 16.6571C5.35941 16.409 4.59177 15.8513 4.03374 15.2734C3.35368 14.5691 2.73951 13.9221 2.24289 13.3434C1.7396 12.757 1.38925 12.2772 1.20897 11.9066C1.15264 11.7908 1.15537 11.6048 1.39418 11.4086C1.62692 11.2173 2.02021 11.1011 2.46209 11.2433C2.60912 11.2906 2.7675 11.3952 2.95738 11.5807C3.13356 11.7528 3.30331 11.9596 3.50418 12.2044C3.52397 12.2285 3.54406 12.253 3.5645 12.2779C3.98758 12.7925 4.55347 13.4752 5.39269 13.7569C6.31234 14.0655 7.14161 13.6954 7.69679 13.1599C8.23664 12.6391 8.61465 11.8747 8.61465 11.1702C8.61465 10.4497 8.22188 9.74626 7.7136 9.21513C7.1944 8.67257 6.47996 8.22801 5.69255 8.06283C5.15918 7.95094 4.62617 8.15731 4.2122 8.36469C3.92488 8.50863 3.61141 8.6996 3.32532 8.87389C3.19541 8.95304 3.07114 9.02874 2.95753 9.09505C2.54864 9.33367 2.24393 9.47343 2.01683 9.50226C1.91718 9.51491 1.85957 9.50191 1.82331 9.48573C1.78944 9.47061 1.73226 9.4343 1.66189 9.32583L1.66171 9.32555C1.6559 9.3166 1.64143 9.29431 1.65212 9.2201C1.66462 9.13335 1.70996 9.00114 1.81552 8.82447C2.02726 8.4701 2.4093 8.05544 2.89245 7.65121C3.36978 7.25186 3.9137 6.88943 4.41775 6.62975C4.94253 6.35939 5.34982 6.23925 5.57506 6.23925C5.83462 6.23925 6.20294 6.32843 6.66485 6.50949C7.11648 6.68653 7.61185 6.93274 8.11157 7.20496C8.61019 7.47658 9.10087 7.76727 9.5459 8.0314L9.5858 8.05509C10.0076 8.30546 10.3995 8.53808 10.6977 8.69132L11.2231 7.61122C10.9571 7.47449 10.5905 7.25693 10.144 6.99189L10.1335 6.98567C9.91945 6.85862 9.69019 6.72264 9.45173 6.58407C9.13498 5.97385 8.55495 5.25083 8.02547 4.61425C7.88599 4.44656 7.74917 4.28386 7.6177 4.12754C7.16094 3.58443 6.76881 3.11816 6.55411 2.78572C6.1388 2.14271 6.24747 1.79049 6.31057 1.693C6.36322 1.61166 6.50995 1.50773 6.78105 1.64704C7.10545 1.81374 7.65402 2.29112 8.33271 3.0181C8.99193 3.72421 9.72106 4.60738 10.4007 5.51413C11.0809 6.42159 11.7028 7.34101 12.1513 8.11835C12.376 8.50767 12.5512 8.8511 12.6684 9.13298C12.7396 9.30416 12.7805 9.43213 12.8026 9.52168ZM3.26147 10.3008C3.45139 10.4187 3.61855 10.5605 3.76684 10.7054C3.99313 10.9264 4.20594 11.1861 4.39811 11.4206C4.41969 11.4469 4.44101 11.4729 4.46206 11.4985C4.91157 12.0454 5.2803 12.4488 5.75742 12.6089C6.15415 12.7421 6.55093 12.609 6.8927 12.2793C7.2498 11.9349 7.43966 11.4721 7.43966 11.1702C7.43966 10.8844 7.26457 10.4681 6.87589 10.0619C6.49814 9.66716 5.98653 9.35699 5.45757 9.24603C5.33277 9.21985 5.10884 9.25892 4.72702 9.4502C4.48167 9.57311 4.24325 9.71867 3.98314 9.87746C3.84251 9.96332 3.69554 10.053 3.53771 10.1452C3.4493 10.1967 3.35692 10.2494 3.26147 10.3008Z"
                              fill="#486497"
                            />
                          </svg>
                          <span>{`e-mail(s) d’invitation envoyé`}</span>
                        </div>
                        <button
                          className="bg-secondary p-3.5 text-white btn"
                          onClick={() => {
                            updateState();
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 10.616C7.71095 10.616 7.47674 10.3818 7.47674 10.0928V8.52304H5.90696C5.61791 8.52304 5.3837 8.28883 5.3837 7.99979C5.3837 7.71075 5.61791 7.47654 5.90696 7.47654H7.47674V5.90681C7.47674 5.61776 7.71095 5.38356 8 5.38356C8.28905 5.38356 8.52326 5.61776 8.52326 5.90681V7.47654H10.093C10.3821 7.47654 10.6163 7.71075 10.6163 7.99979C10.6163 8.28883 10.3821 8.52304 10.093 8.52304H8.52326V10.0928C8.52326 10.3818 8.28905 10.616 8 10.616Z"
                              fill="white"
                            />
                            <path
                              d="M8 15.4998C6.30903 15.4998 5.08711 15.4998 4.10255 15.3673C2.99595 15.2185 2.24727 14.897 1.67482 14.3248C1.10259 13.7526 0.781096 13.0039 0.63228 11.8973C0.5 10.9126 0.5 9.69092 0.5 7.99979C0.5 6.30866 0.5 5.08719 0.63249 4.10244C0.781305 2.99588 1.1028 2.24722 1.67503 1.67479C2.24727 1.10236 2.99595 0.781088 4.10255 0.632486C5.08732 0.5 6.30903 0.5 8 0.5C9.69097 0.5 10.9129 0.5 11.8975 0.632486C13.004 0.781297 13.7527 1.10278 14.325 1.675C15.1645 2.5145 15.3861 3.68448 15.4609 5.18326C15.4753 5.47188 15.253 5.7176 14.9642 5.73183C14.676 5.74669 14.4298 5.524 14.4156 5.23538C14.3396 3.70896 14.1144 2.94461 13.5849 2.41508C12.7165 1.5467 11.1402 1.5467 7.99979 1.5467C4.85939 1.5467 3.28312 1.5467 2.41472 2.41508C1.54631 3.28346 1.54631 4.85969 1.54631 8C1.54631 11.1403 1.54631 12.7165 2.41472 13.5849C3.28312 14.4535 4.85939 14.4535 7.99979 14.4535C11.1402 14.4535 12.7165 14.4535 13.5849 13.5851C14.4535 12.7167 14.4535 11.1405 14.4535 8.00021C14.4535 7.71117 14.6877 7.47696 14.9767 7.47696C15.2658 7.47696 15.5 7.71117 15.5 8.00021C15.5 9.69113 15.5 10.913 15.3675 11.8976C15.2187 13.0041 14.8972 13.7528 14.325 14.325C13.7527 14.8972 13.004 15.2189 11.8975 15.3675C10.9129 15.5 9.69097 15.5 8 15.5V15.4998Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                    <label
                      id="name"
                      className="label text-md text-primary flex-row"
                    >
                      ⚠️ vous devez vous assurer au préalable d’avoir recueilli
                      l’accord de votre contact avant de lui envoyer un email
                      d’invitation. <br />
                      Tout abus ou manquement aux règles d’utilisation de cette
                      fonctionnalité entraînera la suppression immédiate et sans
                      préavis de votre profil affiliateur.
                    </label>
                  </div>
                </div>
                {/* <div className="w-full flex flex-col gap-y-1.5">
                  <h3 className="text-primary font-semibold text-lg pb-5">
                    Éléments graphiques à utiliser
                  </h3>
                  <div>
                    <a
                      href="https://www.dropbox.com/home/Screebot/Espace%20Affiliation"
                      target="_blank"
                      rel="noreferrer"
                      className={`w-fit padding-custom-button flex flex-row gap-x-3 bg-white text-secondary border border-gray-custom-input rounded-custom-input btn whitespace-nowrap`}
                    >
                      <svg
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6992 3.61881V2.85517C13.6992 2.06839 13.0744 1.4436 12.2876 1.4436H7.15041L7.08099 1.25848C6.91901 0.841948 6.52562 0.587402 6.08595 0.587402H1.41157C0.624793 0.587402 0 1.2122 0 1.99897V11.0006C0 11.7874 0.624793 12.4122 1.41157 12.4122H12.5884C13.3752 12.4122 14 11.7874 14 11.0006V4.33616C14 4.05848 13.8843 3.80393 13.6992 3.61881ZM12.2876 2.46178C12.4959 2.46178 12.6579 2.62377 12.6579 2.83203V3.2717H7.89091L7.56694 2.46178H12.2876ZM12.9587 11.0006C12.9587 11.2089 12.7967 11.3709 12.5884 11.3709H1.41157C1.20331 11.3709 1.04132 11.2089 1.04132 11.0006V1.97583C1.04132 1.76757 1.20331 1.60558 1.41157 1.60558L6.10909 1.62872L7.05785 3.98906C7.12727 4.19732 7.33554 4.31302 7.5438 4.31302H12.9355C12.9355 4.31302 12.9587 4.31302 12.9587 4.33616V11.0006Z"
                          fill="#486497"
                        />
                      </svg>
                      éléments graphiques
                    </a>
                  </div>
                </div> */}
              </div>
            </>
          )}
          {index === 2 && (
            <>
              <h3 className="text-primary font-semibold text-lg">
                Espace comptabilité
              </h3>
              <div className="screebot-card flex flex-col w-full">
                {!transactions?.length > 0 && (
                  <div className="text-error font-medium text-lg">
                    Aucune transaction
                  </div>
                )}
                {transactions &&
                  transactions.map((transaction, index) => (
                    <div key={index}>
                      <Transaction
                        from="big_card"
                        view="user"
                        transaction={transaction}
                      ></Transaction>
                      {index !== transactions.length - 1 && (
                        <hr className="transaction-divider" />
                      )}
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    )
  );
}

export default Affiliater;
